import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, exhaustMap, catchError, tap } from 'rxjs/operators';
import { CoreActions } from '../actions/core.actions';
import { Store } from '@ngrx/store';
import { selectCoreStore, selectRedirectUrl } from '../selectors/core.selectors';

@Injectable()
export class CoreEffects {
    private action$ = inject(Actions);
    private router = inject(Router);
    private store = inject(Store)

    loginRedirect$ = createEffect(() => {
        return this.action$.pipe(
            ofType(CoreActions.loginRedirectURL),
            exhaustMap(() => 
                this.store.select(selectCoreStore).pipe(
                    tap(state => {
                        if (state?.redirectUrl) {
                            this.router.navigateByUrl('/' + state.redirectUrl);
                        }
                        else {
                            this.router.navigateByUrl('/events');
                        }
                    })
                )
            )
        )
    },{ dispatch: false })
}